import State from './State.js';

export default class StatePreGame extends State {
    constructor(context) {
        super(context);
        this.name = 'preGame';
    }
    setup() {
        //reset Match 
        this.context.eventLog = [];
        this.context.startTime = Date.now();

        this.context.roundNumber = 0;
        this.context.roundLog = [];
        this.context.matchPoints = {};

        this.context.matchWinner = null;
        this.context.isSkunked = false;
        this.context.playCount = null;
        this.context.playerTurn = "";
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";
        this.context.dealer = null;
        this.context.quitReason = "";

        if (this.context.player1) this.context.player1.ready = false;
        if (this.context.player2) this.context.player2.ready = false;
        if (this.context.player1) this.context.player1.quitReason = null;
        if (this.context.player2) this.context.player2.quitReason = null;

        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.pile = "deck"
            card.pilez = i;
            card.showfront = true;
        }
        this.context.sendEvent("cardMoved");
    }

    action(command, value, player) {
        switch (command) {
            case "start": return this.newGame(player); break;
            case "loadGame": return this.loadGame(value); break;
            default: return this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        let player1 = this.context.player1;
        let player2 = this.context.player2;
        if (this.getPlayerCount() >= 2) {
            actions.push({ command: "start", value: null });
        }

        actions.push({ command: "loadGame", value: null });
        return actions;
    }
    getPlayerCount() {
        let playerCount = 0;
        let player1 = this.context.player1;
        let player2 = this.context.player2;
        if (player1 && Object.keys(player1).length !== 0) {
            playerCount += 1;
        }
        if (player2 && Object.keys(player2).length !== 0) {
            playerCount += 1;
        }
        return playerCount;
    }
    newGame(player) {
        let player1 = this.context.player1;
        let player2 = this.context.player2;

        if (this.getPlayerCount() < 2) {
            this.invalidMove("Need 2 players to start a game", player);
            return;
        }

        if (player === "player1" || !player) player1.ready = true;
        if (player === "player2" || !player) player2.ready = true;

        if ((player1 && player1.ready) && (player2 && player2.ready)) {
            //reset match points event
            this.context.sendEvent("matchPoints", this.context.matchPoints);
            this.context.setState("startRound");
        }
        if(player){
            this.context.playerTurn = player;
            //this.context.chat("Ready",player);
        }

        return true;
    }
    loadGame(matchData) {
        //todo: load match
        this.context.setState("startRound");
        return true;
    }
    //note: move invalidMove and unknownCommand to context? so no events are called from state?
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}